import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "filterArea" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "no-results"
}
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "postal-card-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostalCardPreviewComponent = _resolveComponent("PostalCardPreviewComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Collection de cartes postales", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Sélectionner une carte pour consulter ses informations", -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("label", { for: "filter" }, "Filtrer par lieu :", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLocation) = $event)),
        id: "filter"
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("option", { value: "" }, "Tous les lieux", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueLocations, (location) => {
          return (_openBlock(), _createElementBlock("option", {
            key: location,
            value: location
          }, _toDisplayString(location), 9, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.selectedLocation]
      ])
    ]),
    (_ctx.filteredCards.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Aucun résultat trouvé 👀 "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "actionButton",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
      }, "Réinitialiser")
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCards, (card) => {
        return (_openBlock(), _createBlock(_component_PostalCardPreviewComponent, {
          key: card.id,
          card: card
        }, null, 8, ["card"]))
      }), 128))
    ]),
    _createVNode(_component_ButtonComponent, {
      label: "Retour à l'accueil",
      to: "/"
    })
  ]))
}